import React, { FC, ReactNode } from "react";
import styles from './ButtomNavButton.module.scss';
export interface BottomNavButtonProps {
	isActive: boolean;
	title: string;
	icon: ReactNode;
	onClick?: () => void;
	route?: string;
}

const ButtomNavButton: FC<BottomNavButtonProps> = ({ icon, title, isActive, onClick }) => {
	return (
		<button className={`${styles.buttomNavButtonContainer} ${isActive? styles.activeButton: styles.inActiveButton} `} onClick={onClick}>
			{icon}
			<span>{title}</span>
		</button>
	);
};

export default ButtomNavButton;
